import { lazy, Suspense } from 'react';
import IndexLayout from "../Layouts/IndexLayout";
import MainLayout from "../Layouts/MainLayout";
import PagesLayaut from '../Layouts/PagesLayaut'
import { createBrowserRouter } from "react-router-dom";
import Spiner from '../Components/Admin/Spiner/Spiner';

// Lazy loading de páginas públicas
const PageProductos = lazy(() => import("./PageProductos/PageProductos"));
const PageDetail = lazy(() => import('../Pages/PageDetail/PageDetail'));
const StockAutos = lazy(() => import("../Components/Stock/Stock"));
const VenderAutoComponent = lazy(() => import("../Components/VenderAutoComponent/VenderAutoComponent"));
const FinanciacionComponent = lazy(() => import("../Components/FinanciacionComponent/FinanciacionComponent"));
const Nosotros = lazy(() => import("../Components/Nosotros/Nosotros"));

// Lazy loading de páginas administrativas
const Main = lazy(() => import("./Main/Main"));
const Productos = lazy(() => import('../Pages/Productos/Productos'));
const Usuarios = lazy(() => import('../Pages/Usuarios/Usuarios'));
const Banners = lazy(() => import("./Banners/Banners"));
const Contacto = lazy(() => import("./Contacto/Contacto"));
const Categorias = lazy(() => import("./Categorias/Categorias"));
const Marcas = lazy(() => import("./Marcas/Marcas"));
const Codigos = lazy(() => import("./Codigos/Codigos"));
const Pedidos = lazy(() => import("./Pedidos/Pedidos"));
const Clients = lazy(() => import("../Components/Admin/Clients/index"));

// Componente wrapper para Suspense
const SuspenseWrapper = ({ children }) => (
  <Suspense fallback={<Spiner />}>
    {children}
  </Suspense>
);

export const router = createBrowserRouter([
  {
    path: "/",
    element: <IndexLayout />,
    children: [
      {
        path: `/`,
        element: <SuspenseWrapper><PageProductos /></SuspenseWrapper>,
      }
    ]
  },
  {
    path: "/",
    element: <PagesLayaut />,
    children: [
      {
        path: `/producto/:idProducto/:producto`,
        element: <SuspenseWrapper><PageDetail /></SuspenseWrapper>,
      },
      {
        path: `/productos`,
        element: <SuspenseWrapper><PageProductos /></SuspenseWrapper>,
      },
      {
        path: `/stock/autos`,
        element: <SuspenseWrapper><StockAutos vehicleType="autos" /></SuspenseWrapper>,
      },
      {
        path: `/stock/motos`,
        element: <SuspenseWrapper><StockAutos vehicleType="motos" /></SuspenseWrapper>,
      },
      {
        path: `/cotiza`,
        element: <SuspenseWrapper><VenderAutoComponent /></SuspenseWrapper>,
      },
      {
        path: `/financiacion`,
        element: <SuspenseWrapper><FinanciacionComponent /></SuspenseWrapper>,
      },
      {
        path: `/nosotros`,
        element: <SuspenseWrapper><Nosotros /></SuspenseWrapper>,
      },
    ]
  },
  {
    path: "/",
    element: <MainLayout />,
    children: [
      {
        path: `/dashboard`,
        element: <SuspenseWrapper><Main /></SuspenseWrapper>,
      },
      {
        path: `/dashboard/productos`,
        element: <SuspenseWrapper><Productos /></SuspenseWrapper>,
      },
      {
        path: `/dashboard/usuarios`,
        element: <SuspenseWrapper><Usuarios /></SuspenseWrapper>,
      },
      {
        path: `/dashboard/banners`,
        element: <SuspenseWrapper><Banners /></SuspenseWrapper>,
      },
      {
        path: `/dashboard/contacto`,
        element: <SuspenseWrapper><Contacto /></SuspenseWrapper>,
      },
      {
        path: `/dashboard/clients`,
        element: <SuspenseWrapper><Clients /></SuspenseWrapper>,
      },
      {
        path: `/dashboard/categorias`,
        element: <SuspenseWrapper><Categorias /></SuspenseWrapper>,
      },
      {
        path: `/dashboard/codigos`,
        element: <SuspenseWrapper><Codigos /></SuspenseWrapper>,
      },
      {
        path: `/dashboard/pedidos`,
        element: <SuspenseWrapper><Pedidos /></SuspenseWrapper>,
      },
      {
        path: `/dashboard/marcas`,
        element: <SuspenseWrapper><Marcas /></SuspenseWrapper>,
      },
    ],
  },
]);